import React, {useContext} from "react";
import {Link, useNavigate} from "react-router-dom";
import {directusContext} from "../app/DirectusProvider";
import {useTranslation} from "react-i18next";

const MainMenu = () => {
    const {directus, currentUser, version} = useContext(directusContext);
    const {t} = useTranslation();

    if (!directus.auth.token || !currentUser) {
        return null;
    }

    return (
        <section id="bottom-navigation" className="block fixed inset-x-0 bottom-0 z-10 bg-white shadow border-t-2"
                 key={`menu-v${version}`}>
            <div id="tabs" className="flex justify-between">
                <MenuItem text={t("menu.cours")} image={"/static/image/menu/calendar.svg"} link={"/cours"}/>
                <MenuItem text={t("menu.historique")} image={"/static/image/menu/history.svg"} link={"/historique"}/>
                <MenuItem text={t("menu.vueEnsemble")} image={"/static/image/menu/eye.svg"} link={"/vue-ensemble"}/>
                <LogoutButton/>
            </div>
        </section>
    );
}

const MenuItem = ({link, text, image}) => {

    return (
        <Link to={link}
              className="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
            <img src={image} width={25} height={25} className={"inline-block mb-1"} alt={text}/>
            <span className="tab tab-explore block text-xs">{text}</span>
        </Link>
    );
}

const LogoutButton = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const {directus, updateVersion, setCurrentUser} = useContext(directusContext);

    const logout = () => {
        directus.auth.logout().finally(() => {
            localStorage.clear();
            setCurrentUser(null);
            updateVersion();
            navigate("/login");
        });
    };

    return (
        <button type="button" onClick={logout}
                className="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
            <img src={"/static/image/menu/logout.svg"} width={25} height={25} className={"inline-block mb-1"}
                 alt={t("menu.deconnexion")}/>
            <span className="tab tab-explore block text-xs">{t("menu.deconnexion")}</span>
        </button>
    );

};

export default MainMenu;